export default {
  DEFAULT: '/drive/templates',
  APPS: '/drive/apps',
  PAYMENT: '/payment',
  MYDRIVE: '/drive/myDrive',
  PRICING: '/pricing',
  INVITE: '/#invite',
};
